import React, { useEffect, useMemo, useState } from "react";
import { countries, Dropdown_, Input_ } from "monica-alexandria";
import styled from "styled-components";


const InputPhone = styled.div`
  display: grid;
  grid-template-columns: 30% 70%;
  gap : 1rem;
`
export default function Input_Phone({ value, onChange, placeholder, errors, helpers, required, onBlur }) {
  const sortedCountries = useMemo(
    () => [...(countries || [])].sort((a, b) => a.country.localeCompare(b.country)),
    []
  );

  const defaultCountry = useMemo(() => {
    return (
      sortedCountries.find((item) => item.phoneCode === "+30") ||
      sortedCountries[0] ||
      { phoneCode: "", flag: "" }
    );
  }, [sortedCountries]);

  const parsePhoneValue = (tel) => {
    const raw = String(tel || "").trim();
    if (!raw) {
      return { country: defaultCountry, localNumber: "" };
    }

    const normalized = raw.replace(/\s+/g, "");
    const matchedCountry = sortedCountries
      .slice()
      .sort(
        (a, b) => String(b.phoneCode || "").length - String(a.phoneCode || "").length
      )
      .find((item) => normalized.startsWith(String(item.phoneCode || "")));

    if (!matchedCountry) {
      return { country: defaultCountry, localNumber: normalized };
    }

    return {
      country: matchedCountry,
      localNumber: normalized.slice(String(matchedCountry.phoneCode || "").length),
    };
  };

  const initialParsedPhone = parsePhoneValue(value);
  const [selectedCountry, setSelectedCountry] = useState(initialParsedPhone.country);
  const [phoneNumber, setPhoneNumber] = useState(initialParsedPhone.localNumber);

  useEffect(() => {
    const parsed = parsePhoneValue(value);
    setSelectedCountry(parsed.country);
    setPhoneNumber(parsed.localNumber);
  }, [value]);

  const buildPhoneValue = (countryCode, localNumber) => {
    const cleanLocal = String(localNumber || "").replace(/\s+/g, "");
    if (!cleanLocal) return "";
    return `${countryCode || ""}${cleanLocal}`;
  };

  const handleCountryChange = (e) => {
    const nextCode = e.target.value;
    const nextCountry =
      sortedCountries.find((item) => item.phoneCode === nextCode) || defaultCountry;
    setSelectedCountry(nextCountry);
    onChange?.(buildPhoneValue(nextCode, phoneNumber));
  };

  const handlePhoneChange = (e) => {
    const nextLocal = e.target.value;
    setPhoneNumber(nextLocal);
    onChange?.(buildPhoneValue(selectedCountry?.phoneCode, nextLocal));
  };

  return (
    <InputPhone>
      <Dropdown_>
        <select
          value={selectedCountry.phoneCode}
          onChange={handleCountryChange}
          className="Dropdown_EmojiAdapt"
        >
          {sortedCountries.map((item, i) => (
            <option key={i} value={item.phoneCode}>
              {item.flag} {item.country} {item.phoneCode}
            </option>
          ))}
        </select>
      </Dropdown_>
      <Input_
        placeholder={placeholder || "Phone number"}
        value={phoneNumber}
        onChange={handlePhoneChange}
        onBlur={onBlur}
        errors={errors}
        helpers={helpers}
        required={required}
      />
    </InputPhone>
  );
}
